import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const startRecording = async ({
  sessionId,
}: {
  sessionId: string;
}): Promise<void> => {
  const response = await axiosClient.post(
    `/recordings/${sessionId}/start-recording`,
  );
  return response.data;
};

function useStartRecording(
  mutationOptions?: Partial<
    UseMutationOptions<void, HttpError, { sessionId: string }>
  >,
) {
  return useMutation({
    mutationFn: ({ sessionId }) => startRecording({ sessionId }),
    ...mutationOptions,
  });
}

const stopRecording = async ({
  sessionId,
}: {
  sessionId: string;
}): Promise<void> => {
  const response = await axiosClient.post(
    `/recordings/${sessionId}/stop-recording`,
  );
  return response.data;
};

function useStopRecording(
  mutationOptions?: Partial<
    UseMutationOptions<void, HttpError, { sessionId: string }>
  >,
) {
  return useMutation({
    mutationFn: ({ sessionId }) => stopRecording({ sessionId }),
    ...mutationOptions,
  });
}

export { useStartRecording, useStopRecording };
